import { useMemo } from 'react';
import type { SelfServiceData, Step, StepId } from '../../types';
import type { WizardPhaseDefinition } from '../flowTypes';
import { calculateProgress } from '../utils/progress';

interface UseWizardProgressParams {
  history: StepId[];
  currentStepId: StepId;
  steps: Partial<Record<StepId, Step>>;
  phases: ReadonlyArray<WizardPhaseDefinition>;
  selfServiceData: SelfServiceData;
  startStep: StepId;
}

export const useWizardProgress = ({
  history,
  currentStepId,
  steps,
  phases,
  selfServiceData,
  startStep
}: UseWizardProgressParams) => {
  return useMemo(
    () => calculateProgress(history, currentStepId, steps, phases, selfServiceData, startStep),
    [history, currentStepId, steps, phases, selfServiceData, startStep]
  );
};
